module.exports = __webpack_public_path__ + "static/media/landscape-background.03529423.jpg";